export default __webpack_public_path__ + "static/media/Image-10.51257c39.jpg";